import * as moment from 'moment';

import { DataIdArrayConverterFactory, DataIdConverterFactory } from 'src/app/core/services/mapper/data-id.converter';

import { Assemblage } from './assemblage.model';
import { DateConverter } from 'src/app/core/services/mapper/converters';
import { Cepage } from './cepage.model';
import { AcheteurExport } from './acheteur-export.model';
import { Site } from './site.model';
import { Produit } from '../../habilitation/models/produit.model';
import { ArrayClassConverterFactory } from 'src/app/core/services/mapper/data-property.converter';

export class SaisieTransaction {
    static jsonMap = {
        idMouvement: { key: 'idMouvement', optional: true },
        codeProduit: { key: 'codeProduit', optional: true, default: '' },
        numeroContrat: { key: 'numeroContrat', optional: true, default: '' },
        date: { key: 'dateRetiraison', converter: new DateConverter(), optional: true },
        logement: { key: 'logement', optional: true, default: '' },
        numeroLot: { key: 'numeroLot', optional: true, default: '' },
        volume: { key: 'volume' },
        idSite: { key: 'idSite' },
        observation: { key: 'observation', optional: true, default: '' },
        cepages: { key: 'idsCepages', converter: new (DataIdArrayConverterFactory.build(Cepage, 'cepages'))(), optional: true, default: () => [] },
        assemblages: { key: 'assemblages', converter: new (ArrayClassConverterFactory.build(Assemblage))(), optional: true, default: () => [] },
        idAcheteurFrance: { key: 'idAcheteurFrance', optional: true },
        idAcheteurExport: { key: 'idAcheteurExport', optional: true },
        acheteur: { key: 'acheteur', optional: true, default: '' },
        vendeur: { key: 'vendeur', optional: true, default: '' },
        idVendeur: { key: 'idVendeur', optional: true }
    };

    idMouvement: number;
    codeProduit: string;
    numeroContrat: string;
    date: moment.Moment;
    logement: string;
    numeroLot: string;
    volume: number;
    idSite: number;
    observation: string;
    cepages: Cepage[];
    assemblages: Assemblage[] = [];
    idAcheteurFrance: number;
    idAcheteurExport: number;
    acheteur: string;
    vendeur: string;
    idVendeur: number;

    produit: Produit = new Produit();
    site: Site;
    idOperateur: number;
}
